import { createSlice } from '@reduxjs/toolkit'
import { register } from '../../../../helpers/reducerRegistry'
import { getSummaryHighlight } from './thunk'

const initialState = {
  highlight: {},

  loading: {
    highlight: true,
  },
}

const slice = createSlice({
  name: 'portfolio/common/summaryHighlight',
  initialState,
  reducers: {
    resetStore: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(getSummaryHighlight.pending, (state) => {
      state.loading.highlight = true
    })
    builder.addCase(getSummaryHighlight.fulfilled, (state, { payload }) => {
      state.highlight = payload || {}
      state.loading.highlight = false
    })
    builder.addCase(getSummaryHighlight.rejected, (state, action) => {
      state.loading.highlight = action.payload.loading
    })
  },
})

export const selectHighlight = (state) => state[slice.name].highlight

export const selectLoading = (type) => (state) => {
  const loadingObj = state[slice.name].loading
  if (!type) return Object.values(loadingObj).some(Boolean)
  return loadingObj[type]
}

export const { resetStore } = slice.actions

register(slice.name, slice.reducer)
